import React, { useState, useEffect } from 'react';
import { Form, Container } from 'react-bootstrap';
import HTMLReactParser from 'html-react-parser';
import './index.css';

const ConsentSection = ({
  onConsentChange,
  hasConsent,
  showClickToMoreOpt = true
}) => {
  const [showDetailedConsent, setShowDetailedConsent] = useState(false);
  const [consentData, setConsentData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConsentData = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_LEAD_GENERATION_CONSENT_JSON);
        const data = await response.json();

        const selectedDomain = data['swmc.com'] ? 'swmc.com' : 'swmc.com';
        const domainData = data[selectedDomain];

        setConsentData({
          submitButtonConsent: domainData.submit_button_consent['en'],
          automatedPhoneSolicitationConsent: domainData.automated_phone_solicitation_consent['en'],
          version: domainData.version
        });

        // Remove the onConsentChange(true) call from here - let parent component control initial state
      } catch (error) {
        console.error('Error fetching consent data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchConsentData();
  }, []); // Remove onConsentChange from dependency array to prevent re-runs
  useEffect(() => {
    if (consentData) {
      const consentElement = document.querySelector('.button-name');
      if (consentElement) {
        consentElement.innerText = 'clicking Submit';  
      }
    }
  }, [consentData]);

  // Handle radio button changes explicitly
  const handleRadioChange = (value) => {
    if (onConsentChange) {
      onConsentChange(value);
    }
  };

  if (loading) {
    return <div>Loading consent information...</div>;
  }

  return (
    <div className="consent-section common-form-component">
      <div className="consentDesc">
        {/* First page consent text */}
        {!showClickToMoreOpt && consentData?.submitButtonConsent && (
          <p className="consent-font mb-4">
            {HTMLReactParser(consentData.submitButtonConsent.content)}
          </p>
        )}

        {/* Second page consent section */}
        {showClickToMoreOpt && (
          <>
            <div className="contactconsent">
              <h6 className="consentSmall" onClick={() => setShowDetailedConsent(!showDetailedConsent)}>
                Do you consent to Automated Phone Solicitation?{" "}
                <span className="consentLink">
                  (click to {showDetailedConsent ? 'show less' : 'show more'})
                </span>
              </h6>

              {showDetailedConsent && consentData?.automatedPhoneSolicitationConsent && (
                <p className="consent-font">
                  {HTMLReactParser(consentData.automatedPhoneSolicitationConsent.content)}
                </p>
              )}
            </div>

            <Container className="consnt p-0">
              <div>
                <Form.Check
                  label="I Consent"
                  type="radio"
                  className="checkboxConsent"
                  name="TCPA_Consent_Given"
                  id="iConsent"
                  checked={hasConsent === true}
                  onChange={() => handleRadioChange(true)}
                  // Remove defaultChecked to avoid conflicts with checked prop
                />
              </div>
              <div>
                <Form.Check
                  label="I DO NOT Consent"
                  type="radio"
                  className="checkboxConsent check3"
                  name="TCPA_Consent_Given"
                  id="iDoNotConsent"
                  checked={hasConsent === false}
                  onChange={() => handleRadioChange(false)}
                />
              </div>
            </Container>
          </>
        )}
      </div>
    </div>
  );
};

export default ConsentSection;